/**
 * @fileOverView
 * @description Event Log Page View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var ServiceAuthPageTemplate = require('../../templates/pages/serviceauthpage.html');
var AmpersandView = require('ampersand-view');
var HeaderView = require('../widgets/header');
var FooterView = require('../widgets/footer');
var ServiceAuthView = require('../widgets/serviceauthview');
var ServiceAuthModel = require('../../models/serviceauth');
var app = require('ampersand-app');

var ServiceAuthPageView = AmpersandView.extend({

    template : ServiceAuthPageTemplate,

    pageName: "ServiceAuthPage",

    initialize: function(options){
        this.model = options.serviceAuthModel || new ServiceAuthModel();
        
        if (!options.serviceAuthModel) {
            const client = app.queryParams.client_id || window.localStorage.getItem('serviceAuth') || "";
            this.model.set('service', client);
        }
        
        this.listenTo(this.model, 'change:shortName', this.updateHeaderTitle);
    },

    subviews: {
        mpheader: {
            selector : 'header',
            prepareView: function(el) {
                app.currentPageName = this.pageName;
                const title = this.model.shortName ? 
                    'Vybit Authentication for ' + this.model.shortName : 
                    'Vybit Authentication';
                    
                this.headerView = new HeaderView({
                    el: el,
                    parent: this,
                    maintitle: title,
                    noback: true,
                    login: true
                });
                return this.headerView;
            }
        },

        serviceAuth: {
            selector : '#content',
            prepareView: function(el) {
                app.currentPageName = this.pageName;
                return new ServiceAuthView({
                    el: el,
                    parent: this,
                    model: this.model
                });
            }
        }
    },

    events: {
        "click #refresh" : "refreshServiceAuth",
        "click #clear" : "clearServiceAuth"
    },

    refreshServiceAuth: function(){
        const records = [...app.serviceAuth.records];
        document.getElementById("content").innerHTML = records.reverse().join('<br/><br/>\n');
    },

    clearServiceAuth: function(){
        app.serviceAuth.clear();
        this.refreshServiceAuth();
    },

    updateHeaderTitle: function() {
        if (this.headerView && this.model.shortName) {
            const newTitle = 'Vybit Authentication for ' + this.model.shortName;
            this.headerView.model.set('maintitle', newTitle);
        }
    }

});

module.exports = ServiceAuthPageView;
